import React, { useEffect, useState, useRef, useCallback } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ProductList.css';
import './NewItemsCarousel.css';
import { IoIosBasket } from 'react-icons/io';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import useAddToCart from './AddToCartButton';
import { useCart } from './CartContext';
import BASE_URL, { getImageURL } from '../config';


const CategoryTabs = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { handleAddToCart } = useAddToCart();
  const { fetchCart } = useCart();
  const scrollRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const updateScrollButtons = useCallback(() => {
    if (!scrollRef.current) return;
    const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
    setCanScrollLeft(scrollLeft > 5);
    setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 5);
  }, []);

  useEffect(() => {
    axios.get(`${BASE_URL}/api/products/?format=json`)
      .then((res) => {
        const newProducts = res.data.filter(p => p.label === 'New');
        setProducts(newProducts);
        setLoading(false);
      })
      .catch(err => {
        setError(err);
        setLoading(false);
      });
  }, []);

  // Update arrow visibility on scroll / resize
  useEffect(() => {
    updateScrollButtons();
    const el = scrollRef.current;
    if (el) {
      el.addEventListener('scroll', updateScrollButtons);
      window.addEventListener('resize', updateScrollButtons);
    }
    return () => {
      if (el) el.removeEventListener('scroll', updateScrollButtons);
      window.removeEventListener('resize', updateScrollButtons);
    };
  }, [products, updateScrollButtons]);

  // Auto-scroll right every 2 seconds
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    const timer = setInterval(() => {
      const { scrollLeft, scrollWidth, clientWidth } = el;
      if (scrollLeft + clientWidth >= scrollWidth - 5) {
        el.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        const cardWidth = el.querySelector('.nic-card')?.offsetWidth || 260;
        el.scrollBy({ left: cardWidth + 16, behavior: 'smooth' });
      }
    }, 2000);
    return () => clearInterval(timer);
  }, [products]);

  const scroll = (direction) => {
    if (!scrollRef.current) return;
    const cardWidth = scrollRef.current.querySelector('.nic-card')?.offsetWidth || 260;
    const distance = (cardWidth + 16) * 2;
    scrollRef.current.scrollBy({ left: direction === 'left' ? -distance : distance, behavior: 'smooth' });
  };



if (loading) {
  return (
    <div className="loading-container">
      <div className="spinner-border text-primary" role="status">
      </div>
    </div>
  );
}

if (error) return null;

  return (
    <div id="products" className="container mt-3">

        {loading && (
      <div className="loading-container">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    )}

    <div className="category-row">
      <h2>New in Vegbox</h2>
    </div>
      {/* Product Carousel */}
      <div className="nic-wrapper mt-3">
        {canScrollLeft && (
          <button className="nic-arrow left" onClick={() => scroll('left')}><FiChevronLeft /></button>
        )}
        {canScrollRight && (
          <button className="nic-arrow right" onClick={() => scroll('right')}><FiChevronRight /></button>
        )}
        <div className="nic-track" ref={scrollRef}>
        {products.length > 0 ? (
          products.map(product => (
            <div key={product.id} className="nic-card">
              <div className="card h-100 position-relative">
              <button
              
              className="labelstyle"
            >
              {product.label}
            </button>
                {product.label !== 'Service' && (
                <button
                  onClick={() => handleAddToCart(product.slug, 1, fetchCart)}
                  disabled={product.stock !== null && product.stock !== undefined && product.stock <= 0}
                  className="add-to-cart-button"
                >
                  <IoIosBasket />
                </button>
                )}

                {/* Out of stock badge */}
                {product.stock !== null && product.stock !== undefined && product.stock <= 0 && (
                  <span className="stock-badge-card out-of-stock">Out of stock</span>
                )}

                <Link to={`/product/${product.slug}`}>
                <img
  src={getImageURL(product.mainimage)}
  alt={product.title}
  className="card-img-top product-image"
  loading="lazy"
/>
                </Link>
                <div className="card-body text-center">
                  <h5 className="card-title">{product.title}</h5>

                  <p className="card-text">
                    {product.label === 'Service'
                      ? <strong><Link to={`/product/${product.slug}`} className="get-quote-link">Get a Quote</Link></strong>
                      : <><strong>Price:</strong> CHF {product.price}</>
                    }
                  </p>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>No products available.</p>
        )}
        </div>
      </div>
    </div>
  );
};

export default CategoryTabs;
